<div class="col-md-12">
  <div class=" border rounded-2 p-4">
    <h3 class="text-center">Kaizen Forecast Adjustments</h3>


    <br><br>
    <form [formGroup]="formForecast" (ngSubmit)="onSubmit()">
      <div class="row">

        <div class="col-sm-2">
          <label for="NAMC">NAMC <span>*</span></label>
          <select class="form-select" formControlName="companyID" required (change)="changeCompany($event)">
            <option value="" selected>Select NAMC</option>
            @for (company of companies; track company) {
              <option [value]="company.companyID">
                {{company.companyName}}
              </option>
            }
          </select>
          @if (formForecast.invalid) {
            <small class="invalid">NAMC is mandatory</small>
          }
        </div>

        <div class="col-sm-3">
          <label for="lineid">LINE <span>*</span></label>
          <select class="form-select" formControlName="lineId" required (change)="changeLine($event)">
            <option value="0" selected>All Lines</option>
            @for (line of  filteredLines; track line) {
              <option [value]="line.lineID">{{line.lineName}}</option>
            }
          </select>

        </div>
        <div class="col-sm-2">
          <label for="lineid">SHOP <span>*</span></label>
          <select class="form-select" formControlName="shopId" required>
            <option value="0" selected>All Shops</option>
            @for (shop of  filteredShops; track shop) {
              <option [value]="shop.shopID">{{shop.name}}</option>
            }
          </select>

        </div>

        <div class="col-sm-2">
          <label for="lineid">FISCAL YEAR <span>*</span></label>
          <select class="form-select" formControlName="finYear" required>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
            <option value="2031">2031</option>
            <option value="2032">2032</option>
            <option value="2033">2033</option>
            <option value="2034">2034</option>
            <option value="2035">2035</option>

          </select>
        </div>
        <div class="col-sm-2" style="padding: 27px 0 0 20px;">

          <button mat-flat-button type="submit" color="primary">Generate</button>
        </div>
      </div>
    </form>
    <br>
      <br>
        @if (generated) {
          <div class="row">
            <form>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col" colspan="9"> <div class="legendouter">* Budget Edited<div class="legend"></div></div></th>
                    <th scope="col" colspan="2" class="bggray"><i>Actuals Reporting</i></th>
                  </tr>
                  <tr>
                    <th scope="col">KZN No#</th>
                    <th scope="col">KZN Name</th>
                    <th scope="col">KZN<br>Created Date<mat-icon  matTooltip="Submitted to the CMD Reviewer for the first time" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">Planned<br>Implementation<br>Date<mat-icon  matTooltip="Calculated on the Fiscal Year" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">Live<mat-icon  matTooltip="Implementation date changed" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">New to<br>Orig Budget<mat-icon  matTooltip="Created Date from 1st Jan to 31st Mar" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">New to Q1F<mat-icon  matTooltip="Created Date from 1st Apr to 31st May" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">New to Q2F<mat-icon  matTooltip="Created Date from 1st Jun to 31st Aug" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col">New to Q3F<mat-icon  matTooltip="Created Date from 1st Sep to 31st Dec" matTooltipPosition="after">help_outline</mat-icon></th>
                    <th scope="col" class="bggray">Confirm Actual <br>Implementation<br>Date</th>
                    <th scope="col" class="bggray">Status</th>
                  </tr>
                </thead>
                <tbody>
                  @for (kaizen of KaizenCombinedAry; track kaizen) {
                    <tr >
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><a class="link" (click)="showDetails(kaizen.kaizenNumber)" >K{{kaizen.kaizenNumber}}</a></td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' ">{{kaizen.title}}</td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' ">{{kaizen.submittedOn | date : 'MM/dd/yyyy'}}</td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' ">{{kaizen.implementationDate | date : 'MM/dd/yyyy'}}</td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><input type="checkbox" class="primary" [checked]="kaizen.forecastAdjLive" (change)="changeBudget(kaizen.kaizenNumber,$event,'forecastAdjLive')"></td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><input type="checkbox" class="primary" [checked]="kaizen.q0F" (change)="changeBudget(kaizen.kaizenNumber,$event,'q0F')"></td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><input type="checkbox" class="primary" [checked]="kaizen.q1F" (change)="changeBudget(kaizen.kaizenNumber,$event,'q1F')"></td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><input type="checkbox" class="primary" [checked]="kaizen.q2F" (change)="changeBudget(kaizen.kaizenNumber,$event,'q2F')"></td>
                      <td [style.background-color]="kaizen.initialBudget==kaizen.updatedBudget ? '': '#ffcccb' "><input type="checkbox" class="primary" [checked]="kaizen.q3F" (change)="changeBudget(kaizen.kaizenNumber,$event,'q3F')"></td>
                      <td class="bggray">{{kaizen.actualImplementation}}</td>
                      <td class="bggray">{{kaizen.forecastStatus}}</td>
                    </tr>
                  }
                </tbody>
              </table>
              <div>
                <br>
                  <button mat-flat-button class="button" type="submit" color="primary" (click)="saveForecast()">Confirm Changes</button>
                  <button mat-flat-button class="button" type="submit" color="primary" (click)="cancel()">Cancel</button>
                </div>
              </form>
            </div>
          }
        </div>
      </div>